// Central API base URL configuration.
// NOTE: Using absolute Function App URL because Static Web App is not linked to the Functions backend.
// To revert to relative '/api' routing later, link the Function App in SWA (Option B) and replace this with '/api'.
export const API_BASE: string =
  (import.meta as any).env?.VITE_API_BASE ?? 'https://coffeerun-dev-func-275qjjl3xwdua.azurewebsites.net/api';
